import React from "react";

/*
 * Content cards per DESIGN.md §4.
 * Light: white, #E5E7EB border, radius 12, raised shadow; hover → elevated + #D2D6DC border.
 * Dark: #161E2E, white/10 border, dark shadows; hover warms surface to #1E2A3C.
 */

export default function Card({
  dark = false,
  hoverable = false,
  padding = "p-6",
  className = "",
  children,
  ...rest
}) {
  const theme = dark
    ? `bg-ic-navy border border-white/10 shadow-ic-raised-dark ${hoverable ? "hover:shadow-ic-elevated-dark hover:bg-ic-navyCard" : ""}`
    : `bg-white border border-ic-lightGray shadow-ic-raised ${hoverable ? "hover:shadow-ic-elevated hover:border-ic-borderGray" : ""}`;
  return (
    <div
      className={`rounded-xl transition-all duration-150 ease-out ${theme} ${padding} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
